module.exports = __webpack_public_path__ + "img/daishenhe.4d7fc042.svg";